import React, { Component } from "react";
import {
  Card,
  FlatButton,
  Divider,
  CardTitle,
  Dialog,
  TextField,
  DialogTitle,
  Snackbar,
  Alert,
} from "material-ui";
import Loading from "../Loading";
import { Link } from "react-router";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";

export default class AddCompany extends Component {
  constructor(props) {
    super(props);
    console.log("this.props---13--------", props);
    this.state = {
      open: false,
      company: this.props.company,
      toastOpen: false,
      responseMsg: "",
      address: "",
    };
  }

  componentWillReceiveProps(props) {
    console.log("props- add company-------", props);
    if (props.company && Object.keys(props.company).length !== 0) {
      //props.clearCompanyData();
      console.log("inside 26", props);
      this.setCurrentCompany(props.company);
    } else if (props.open) {
      console.log("inside 29");
      //props.clearCompanyData();
      this.showAddCompany(props.open);
    }
  }

  setCurrentCompany = (company) => {
    this.setState({ company: company, open: true });
  };

  showAddCompany = (open) => {
    this.setState({ open: open });
  };

  handleChange = (address) => {
    let { company } = this.state;
    console.log("handleChange----------", address);
    company.address = address;
    this.setState({ company: company });
  };

  handleSelect = (address) => {
    console.log("handleSelect address-----------", address);
    let { company } = this.state;
    company.address = address;
    this.setState({ company: company });
    console.log("company address-----------", company);
  };

  notifyFormError(data, msg) {
    console.error("Form error:", data);
    alert(msg);
  }

  addCompany = () => {
    let { company } = this.state;
    var me = this;
    let companyId = company.companyId;
    let companyName = company.company;
    let contactNumber = company.contactNumber;
    let address = company.address;
    let body = {
      companyId: companyId,
      companyName: companyName,
      contactNumber: contactNumber,
      address: address,
      employees: [],
    };

    let url = `/api/payroll/addCompany`;
    let options = {
      method: "POST",
      headers: {
        token: this.props.token.jwt,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };
    fetch(url, options).then((res) => {
      if (res.status >= 200 && res.status < 300) {
        if (res.message == "Company already exist.") {
          this.notifyFormError(res, "Company is already exist.");
        } else {
          console.log("this.props--------", this.props);
          this.setState({ open: false }, () => me.props.closeAddCompanyPopup());
        }
      } else {
        console.log("this.res--------", res);
        this.notifyFormError(res, "Internal server error.");
        this.setState({ open: false });
        me.props.closeAddCompanyPopup();
      }
    });
  };

  updateCompany = () => {
    let { company } = this.state;
    let me = this;
    console.log("this.props---11-----", this.props);
    let companyId = company.companyId;
    let companyName = company.company;
    let contactNumber = company.contactNumber;
    let address = company.address;
    let body = {
      companyId: companyId,
      companyName: companyName,
      contactNumber: contactNumber,
      address: address,
      id: company._id,
    };
    let url = `/api/payroll/editCompany`;
    let options = {
      method: "PUT",
      headers: {
        token: this.props.token.jwt,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };
    fetch(url, options).then((res) => {
      if (res.status >= 200 && res.status < 300) {
        if (res.message == "Company already exist.") {
          this.notifyFormError(res, "Company is already exist.");
        } else {
          this.setState({ open: false }, () => me.props.closeAddCompanyPopup());
        }
      } else {
        this.notifyFormError(res, "Internal server error.");
        this.setState({ open: false }, () => me.props.closeAddCompanyPopup());
      }
    });
  };

  closeCompanyModal = () => {
    var me = this;
    this.setState({ open: false, company: {} }, () =>
      me.props.closeAddCompanyPopup(),
    );
  };

  onChangeValue = (key, value) => {
    let { company } = this.state;
    if (key == "companyId") {
      company.companyId = value;
    } else if (key == "company") {
      company.company = value;
    } else if (key == "contactNumber") {
      company.contactNumber = value;
    } else if (key == "address") {
      company.address = value;
    }
    this.setState({ company: company });
  };

  render() {
    let { toastOpen, responseMsg, open, company } = this.state;
    console.log("open--------", open);
    return (
      <div>
        <Dialog open={open}>
          <Card className="addCompanyHeader">
            <CardTitle title="Add Company" />
          </Card>
          <TextField
            value={company.companyId}
            floatingLabelText="Company Id"
            style={{ width: "22rem", marginTop: "20px" }}
            onChange={(e) => this.onChangeValue("companyId", e.target.value)}
          />
          <TextField
            value={company.company}
            floatingLabelText="Company Name"
            style={{ width: "22rem", marginLeft: "20px" }}
            onChange={(e) => this.onChangeValue("company", e.target.value)}
          />
          <TextField
            value={company.contactNumber}
            floatingLabelText="Contact Number"
            type="phone"
            style={{ width: "22rem", marginLeft: "20px" }}
            onChange={(e) =>
              this.onChangeValue("contactNumber", e.target.value)
            }
          />
          <br />
          <PlacesAutocomplete
            value={company.address}
            onChange={this.handleChange}
            onSelect={this.handleSelect}
          >
            {({
              getInputProps,
              suggestions,
              getSuggestionItemProps,
              loading,
            }) => (
              <div
                style={{
                  width: "97.5%",
                  borderRadius: "0px",
                  marginTop: "2rem",
                }}
              >
                <input
                  {...getInputProps({
                    placeholder: "Search Address ...",
                    className: "location-search-input",
                  })}
                  className="addressField"
                  ref="address"
                />
                <div className="autocomplete-dropdown-container">
                  {loading && <div>Loading...</div>}
                  {suggestions.map((suggestion) => {
                    const className = suggestion.active
                      ? "suggestion-item--active"
                      : "suggestion-item";
                    // inline style for demonstration purpose
                    const style = suggestion.active
                      ? { backgroundColor: "#fafafa", cursor: "pointer" }
                      : { backgroundColor: "#ffffff", cursor: "pointer" };
                    return (
                      <div
                        {...getSuggestionItemProps(suggestion, {
                          className,
                          style,
                        })}
                      >
                        <span>{suggestion.description}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </PlacesAutocomplete>
          <br />
          <div style={{ float: "right" }}>
            <FlatButton
              className="c-btn__secondary"
              type="cancel"
              onTouchTap={this.closeCompanyModal}
            >
              Close
            </FlatButton>
            {company._id ? (
              <FlatButton type="submit" onTouchTap={this.updateCompany}>
                Update
              </FlatButton>
            ) : (
              <FlatButton type="submit" onTouchTap={this.addCompany}>
                Add
              </FlatButton>
            )}
          </div>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/companies/AddCompany.js